(function (sb) {
	var me = (sb.EventCreatorCache = {});
	var eventCreatorDataCache = {};

	me.setEventCreatorDataToCache = function (data, id) {
		eventCreatorDataCache[id] = data;
	};
	me.getEventCreatorDataFromCache = function (id) {
		return eventCreatorDataCache[id];
	};
})(window.Storyboard = (window.Storyboard || {}));

window.EventCreatorSetup = {
	hasUnsavedChanges: false,
	saveSetup: function (eventCreatorElem) {
		var ecLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(eventCreatorElem);

		Storyboard.EventCreatorCache.setEventCreatorDataToCache(null, eventCreatorElem.guid);

		var data = {
			elementItem: eventCreatorElem,
			ecSettings: EventCreatorSetup.getEventCreatorSettings()
		};

		Helpers.perfJSonCall({
			method: "SaveEventCreatorSettings",
			message: "Saving event creator setup",
			data: data,
			successCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get('Event creator settings have been saved.'));
				var items = [ecLayoutElem];
				Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, ecLayoutElem.guid);
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get('Unable to save event creator settings.'));
			}
		});
	},

	getEventCreatorSettings: function () {
		var data = {};
		data.ButtonText = $('#txtECLinkButtonLabel').val();
		data.TargetFormID = $('#ddlECTargetForm').val() || -1;
		data.Filters = EventCreatorSetup.getFilters();
		data.OptionalFilterSettings = EventCreatorSetup.getOptionalFilterSetting();

		var elementsIds = [];
		$('#ecDataObjectsBox option:selected').each(function () { elementsIds.push($(this).val()); });
		data.LayoutElementsToUpdate = elementsIds;

		return data;
	},

	getFilters: function () {
		var filters = [];

		$("#ecFilterBox > div:not(.ecfilterboxTemplate)").each(function () {
			var filterId = $(this).find("#hidFilterId").val();
			var questionId = $(this).find('#hidQuestionId').val();

			var selectedAnswers = [];
			$(this).find("select option:selected[value!=0]").each(function () {
				selectedAnswers.push({ AnswerID: $(this).val() });
			});

			if (selectedAnswers.length > 0) {
				var filter = {
					FilterID: filterId,
					Answers: selectedAnswers,
					QuestionID: questionId
				};

				filters.push(filter);
			}
		});

		return filters;
	},

	getOptionalFilterSetting: function (settingId) {
		var optFilterSettings = [];

		$("#optFilterBoxEC div").each(function () {
			var rowFilter = new Object();
			rowFilter.FilterID = parseInt($(this).find("#hidOptFilterId").val() || "0");
			rowFilter.QuestionID = parseInt($(this).find("#hidOptQuestionId").val() || "0");
			rowFilter.OptionalSettingType = 3;
			rowFilter.IsApply = $(this).find(".chkOptFilter").is(':checked');
			if (rowFilter.FilterID > 0)
				optFilterSettings.push(rowFilter);
		});

		return optFilterSettings;
	},

	setupEditPanel: function (contentElement) {
		$.when(EventCreatorSetup.loadFilters(), EventCreatorSetup.loadFormReports(), EventCreatorSetup.loadLayoutElements())
		.done(function (data1, data2, data3) {
			EventCreatorSetup.bindFilters(data1[0].d);
			EventCreatorSetup.bindFormReports(data2[0].d);
			EventCreatorSetup.bindLayoutElements(data3[0].d);

			Helpers.perfJSonCall({
				method: "GetEventCreatorSettings",
				data: {
					guid: contentElement.guid, layoutElementId: contentElement.layoutElementId || 0
				},
				successCallback: function (settings) {
					EventCreatorSetup.bindEventCreatorSettings(settings);
				},
				failedCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get('Unable to load event creator settings.'));
				},
				fixCasing: true
			});
		});
	},

	bindEventCreatorSettings: function (settings) {
		EventCreatorSetup.setSelectedFilters(settings.filters);
		EventCreatorSetup.setOptionalFilterSettings(settings.optionalFilterSettings);
		HTMLHelpers.setSelectedValues('#ecDataObjectsBox', settings.layoutElementsToUpdate);
		$('#txtECLinkButtonLabel').val(settings.buttonText);
		$('#ddlECTargetForm').val(settings.targetFormID);

		Storyboard.LayoutControls.hideLoadingBar();
	},

	setSelectedFilters: function (filterArray) {
		HTMLHelpers.setSelectedValues($("#ecFilterBox div select"), 0);

		if (filterArray) {
			filterArray.forEach(function(filter) {
				if (!filter.filterId) return;
				var filterbox = $("#ecFilterBox div #hidFilterId[value='" + filter.filterId + "']").parent();
				var answerIds = $.map(filter.answers, function (e) { return isNaN(e.answerId) ? e : e.answerId });
				HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
			});
		}
	},

	setOptionalFilterSettings: function (optionalFilterSettings) {
		if (optionalFilterSettings) {
			optionalFilterSettings.forEach(function(ofs) {
				if (!ofs.optionalSettingType) return;
				if (ofs.optionalSettingType == 3) {
					var questionId = ofs.questionId;
					var isApply = ofs.isApply;
					$("#optFilterBoxEC div").each(function () {
						if (questionId == parseInt($(ofs).find("#hidOptQuestionId").val() || "0")) {
							$(ofs).find(".chkOptFilter").attr("checked", isApply);
						}
					});
				}
			});
		}
	},

	eventUpdateEventCreator: function (layoutElement, ecData) {
		var itemTypes = Storyboard.Constants.itemTypes;
		var ecElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.EVENTCREATOR, layoutElement);
		var ecDiv = $(".layoutElementItem[guid='" + ecElem.guid + "']");

		this.renderEventCreator(ecDiv, ecData, ecElem);
	},

	redrawEventCreator: function (eventCreatorElementItem) {
		if (eventCreatorElementItem != null) {
			eventCreatorElementItem.content = '';
			$('#' + eventCreatorElementItem.guid).html('');
			if (eventCreatorElementItem.guid != '') { //element was saved before
				var ecData = Storyboard.EventCreatorCache.getEventCreatorDataFromCache(eventCreatorElementItem.guid);
				if ((typeof ecData != 'undefined') && (ecData != null)) {
					var ecDiv = $(".layoutElementItem[guid='" + eventCreatorElementItem.guid + "']");
					this.renderEventCreator(ecDiv, ecData, eventCreatorElementItem);
				}
			}
		}
	},

	renderEventCreator: function (ecDiv, ecData, elementItem) {
		var elementItemGuid = elementItem.guid;
		$(ecDiv).empty();
		Storyboard.EventCreatorCache.setEventCreatorDataToCache(ecData, elementItemGuid);
		if (ecData == null) {
			if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
				$(ecDiv).removeClass("layoutElementEventCreator").addClass("layoutElementNoDataText")
					.html($('<span/>', { 'class': 'noData', html: locale.get('no data') }));
			} else {
				$(ecDiv).html("No Data");
			}
		} else {
			$(ecDiv).removeClass("layoutElementNoDataText").addClass('layoutElementEventCreator doNotReload');
			$(ecDiv).html('<span class="DUIButton eventCreatorButton">' + HTMLHelpers.htmlEncode(ecData.ButtonText) + '</span>');
			var eventButton = $(ecDiv).find('.eventCreatorButton');

			if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()) { // disable unless in preview
				eventButton.attr('disabled', 'disabled');
			}
			else {
				eventButton.bind('click', function () {
					Helpers.perfJSonCall({
						method: "GetFormReportUrlForEventCreator",
						data: { layoutElementId: elementItem.layoutElementId },
						successCallback: function (formDetails) {
							EventCreatorSetup.openFormReport(formDetails, elementItemGuid);
						},
						failedCallback: function () {
							Storyboard.LayoutControls.showMessage(locale.get('Unable to get Form report url.'));
						}
					});
				});
			}
		}

		if (!Helpers.isPreview()) {
			$(ecDiv).css({ 'background-image': 'none' });
		}
		Storyboard.LayoutControls.hideLoadingBar();
	},

	loadTabs: function () {
		$('#eventcreatortabholder').tabs('destroy');
		$('#eventcreatortabholder').removeClass('ui-widget');
		$('#eventcreatortabholder').tabs();
	},

	bindFormReports: function (reports) {
		$("#ddlECTargetForm option").remove();
		if (reports.length > 0) {
			var reportOptions = "";
			for (var report in reports)
				if (reports.hasOwnProperty(report)) {
					reports[report].displayString = reports[report].displayString.substr(0, reports[report].displayString.length - 3);
					reportOptions += '<option value="' + reports[report].reportId + '">' + reports[report].displayString + '</option>';
				}

			$("#ddlECTargetForm").append(reportOptions);
		}
	},

	loadFormReports: function () {
		return Helpers.perfJSonCall({
			method: 'GetFormReports',
			fixCasing: true
		});
	},

	bindFilters: function (filterArray) {
		var template = $("#ecFilterBox > .ecfilterboxTemplate");
		template.show();
		Storyboard.GuiEvents.bindFilters(filterArray, "ecFilterBox", "ecfilterboxTemplate", false);
		Storyboard.GuiEvents.bindOptionalFilters(filterArray, "optFilterBoxEC", "optionFilterTemplateEC", "optionalFilterSettingsEC");
		template.hide();
	},

	loadFilters: function () {
		return ChartSetupProxy.GetFilters();
	},

	bindLayoutElements: function (elements) {
		$("#ecDataObjectsBox option").remove();
		if (elements.length > 0) {
			var options = "";
			for (var i = 0; i < elements.length; i++) {
				var types = Storyboard.Constants.itemTypeClearNames;
				var title = types[elements[i].itemType].charAt(0).toUpperCase() + types[elements[i].itemType].slice(1) + ' box ' + elements[i].layoutElementId;

				options += '<option value="' + elements[i].layoutElementId + '">' + title + '</option>';
			}

			$("#ecDataObjectsBox").append(options);
		}
	},

	loadLayoutElements: function () {
		return Helpers.perfJSonCall({
			method: 'GetLayoutElementsAvailableForUpdate',
			fixCasing: true
		});
	},

	openFormReport: function (formDetails, elementGuid) {
		var respondentLockTimer;

		function updateRespondentLock() {
			Helpers.perfJSonCall({
				method: "UpdateEventCreatorLock",
				data: { respondentId: formDetails.respondentId }
			});
			respondentLockTimer = setTimeout(updateRespondentLock, 30000);
		}

		if (formDetails) {
			updateRespondentLock();
			var formHTML = "<iframe id='ifrFormReport' style='width:100%; height:100%; border: 0' scrolling='no' />";
			var formWin = new DUIwindow2({
				title: '',
				width: $("#reportWrapper").width(),
				height: 766,
				buttons: [
					{
						text: 'Save',
						closeWindow: false,
						focused: true,
						onClick: function () {
							var iframe = $('#ifrFormReport')[0];
							var view = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
							if (view)
								$.when(view.DataFieldSetup.saveDataFieldsForRespondent())
									.done(function () {
									    // if datafields validation fails do nothing
									    if (arguments[0] === false) return;

										formWin.Close();

										var ecData = Storyboard.EventCreatorCache.getEventCreatorDataFromCache(elementGuid);
										if (ecData != null && ecData.LayoutElementsToUpdate.length > 0) {
											var tablesToUpdate = [];
											Helpers.ThrottleQueue.clearThrottleQueue();
											$(ecData.LayoutElementsToUpdate).each(function () {
												tablesToUpdate.push(Storyboard.LayoutDesigner.getLayoutElementById(this));
											});
											Storyboard.LayoutDesigner.loadStorytellerContentForElements(tablesToUpdate, true, true, 0, 0, "formSaved_" + elementGuid);
										}

										clearTimeout(respondentLockTimer);
										setTimeout(function () {
											Helpers.perfJSonCall({
												method: "RemoveEventCreatorLock",
												data: { respondentId: formDetails.respondentId }
											});
										}, 30000);
									});
						}
					},
					{
						text: 'Cancel',
						closeWindow: false,
						onClick: function () {
							formWin.Close();

							clearTimeout(respondentLockTimer);
							Helpers.perfJSonCall({
								method: "RemoveEventCreatorLock",
								data: { respondentId: formDetails.respondentId }
							});
						}
					}
				],
				html: formHTML,
				modal: true
			});

			$('#ifrFormReport').attr('src', formDetails.url);
			if ($('#ifrFormReport')[0].contentWindow) {
				$('#ifrFormReport')[0].contentWindow.focus();
			} else if ($('#ifrFormReport')[0].contentDocument && $('#ifrFormReport')[0].contentDocument.documentElement) {
				$('#ifrFormReport')[0].contentDocument.documentElement.focus();
			}
		}
	},
}
